exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".forums .column-header {\n  border-top: 2px solid #e3f0f4;\n  padding: 0.5rem 1rem;\n  color: #7091c5; }\n\n.forums .forum {\n  padding: 0.75rem 1rem;\n  border-top: 2px solid #e3f0f4; }\n  .forums .forum .item-actions {\n    opacity: 0;\n    transition: all 200ms ease-in; }\n  .forums .forum:hover {\n    cursor: pointer; }\n    .forums .forum:hover .item-actions {\n      opacity: 1; }\n  .forums .forum:hover {\n    background-color: #fcf9f3; }\n  .forums .forum .name {\n    font-weight: bold; }\n  .forums .forum .access-level {\n    color: #898a8e;\n    text-align: center; }\n    .forums .forum .access-level .check {\n      color: green !important;\n      font-size: 120%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/forums/forums-list/forums-list.component.scss
// module id = 395
// module chunks = 0